/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import isObject from 'lodash/isObject'
import { compose, withState } from 'recompose'
import { List, ListItem, IconButton } from 'material-ui'
import styled from 'styled-components'
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down'
import ArrowDropUp from 'material-ui/svg-icons/navigation/arrow-drop-up'
import { muiThemeable } from 'material-ui/styles'
import { updateItemArrayByIndex } from 'helpers/arrayHelpers';

const returnFullMenuName = (menu) => (
  isObject(menu.name) ? `${menu.name.en}` : menu.name
)

const StyledListItem = styled(ListItem)`
  border-left: 3px solid transparent !important;
  ${({ muiTheme }) => ({
    ':hover': {
      borderLeft: `3px solid ${muiTheme.palette.accent1Color} !important`,
    },
  })}
`

const ExtendableList = compose(
  withState('active', 'setActive', [null, null, null, null]),
  muiThemeable(),
)(
  ({
    treeList,
    className,
    active,
    setActive,
    onClick,
    getChildren,
    getLabel,
    muiTheme,
  }) => {
    const selectList = (level, index) => (
      setActive(updateItemArrayByIndex(active, level - 1, (item) => item !== index ? index : null))
    )
    const createFontStyle = (level) => {
      switch (level) {
        case 1: return { fontSize: 18, fontWeight: 500 }
        case 2: return { fontSize: 16, fontWeight: 400 }
        default: return { fontSize: 16, fontWeight: 300 }
      }
    }
    const renderNestedList = (level, items) => (
      (items && level <= 4) ? (
        items.map((item, i) => {
          const children = getChildren(item)
          const isActive = i === active[level - 1]
          const showArrow = children && children.length && level <= 4
          return (
            <StyledListItem
              key={`item-${i}`}
              onClick={() => onClick(item)}
              className={className}
              open={isActive}
              hoverColor={'#f5f5f5'}
              muiTheme={muiTheme}
              primaryText={getLabel(item)}
              innerDivStyle={createFontStyle(level)}
              rightIconButton={
                showArrow ? (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation()
                      selectList(level, i)
                    }}
                  >
                    {isActive ? (
                      <ArrowDropUp />
                    ) : (
                      <ArrowDropDown color={muiTheme.palette.accent1Color}/>
                    )}
                  </IconButton>
                ) : null
              }
              nestedItems={renderNestedList(level + 1, children)}
            />
          )
        })
      ) : null
    )
    return (
      <List>
        {renderNestedList(1, treeList)}
      </List>
    )
  },
)

ExtendableList.propTypes = {
  treeList: PropTypes.array,
  onClick: PropTypes.func,
  getChildren: PropTypes.func,
  getLabel: PropTypes.func,
}
ExtendableList.defaultProps = {
  treeList: [],
  onClick: (item) => console.log(item),
  getChildren: (menu) => menu.children_data || menu.childrenData,
  getLabel: returnFullMenuName,
}

export default ExtendableList



// WEBPACK FOOTER //
// ./src/components/materialUI/ExtendableList.js